document.addEventListener('DOMContentLoaded', function () {
  var carruseles = document.querySelectorAll('.landing-ic-carrusel');

  carruseles.forEach(function (carrusel) {
    var slides = carrusel.querySelectorAll('.landing-ic-carrusel-slide');
    var dots = carrusel.querySelectorAll('.landing-ic-dot');
    var prevBtn = carrusel.querySelector('.landing-ic-arrow--prev');
    var nextBtn = carrusel.querySelector('.landing-ic-arrow--next');
    var autoplayMs = parseInt(carrusel.getAttribute('data-autoplay-ms'), 10) || 4000;
    var current = 0;
    var timer = null;

    if (slides.length <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(next, autoplayMs);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        goTo(index);
        startAutoplay();
      });
    });

    carrusel.addEventListener('mouseenter', stopAutoplay);
    carrusel.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});